import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageService {
  constructor(private translate: TranslateService) {}

  public useBrowserLang() {
    this.translate.setDefaultLang('en');
    this.translate.use(this.getBrowserLang());
  }

  public getBrowserLang() {
    const lang =  this.translate.getBrowserLang();
    if (lang === 'fr'  || lang === 'en') {
      return lang;
    } else {
      return 'en';
    }
    // return this.translate.getBrowserLang() || 'en';
  }
}
